<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager']"> <i class="fa fa-building-o"></i> Lager </a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager', 'uebersicht']"> Übersicht </a>
      </li>
      @for (item of breadCrumb; track $index) {
        <li>
          @if (item.path) {
            <a [routerLink]="item.path">
              <span>{{ item.title }}</span>
            </a>
          } @else {
            <span>{{ item.title }}</span>
          }
        </li>
      }
    </ul>
  </div>

  <a href="/a/artikel/neu" target="_blank" class="bm-btn bm-btn-ghost"> Artikel hinzufügen </a>
  <input class="bm-input" type="text" (input)="quicksearchChanged($event)" placeholder="Schnellfilter" />
</div>

<div class="page-content px-4 pb-2">
  <ag-grid-angular
    class="ag-theme-quartz w-full h-full"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="colDefs"
    [rowClassRules]="rowClassRules"
    [rowSelection]="rowSelection"
    [detailRowAutoHeight]="true"
    [alwaysShowVerticalScroll]="true"
    [localeText]="locale"
    [masterDetail]="true"
    [detailCellRendererParams]="detailCellRendererParams"
    (firstDataRendered)="onFirstDataRendered($event)"
    [pagination]="true"
    [rowData]="articleTemplates"
    [paginationPageSize]="paginationPageSize"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    (gridReady)="onGridReady($event)"
  >
  </ag-grid-angular>
</div>
